// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2xe71QCGjUWpp5qsA1GsaW","logo":"_1KGaR6aNf8jR3sAhPhgrKz","menu":"_3bmvi0fax6psbYeAkOGD25","right":"_3Aou5Yor3TzSZaNcNK0zmF"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Header.less
// module id = 1122
// module chunks = 1